/**
 * KONVERSİYA ZƏNCİRİNİN İLK İKİ PİLLƏSİ — axtarış və kart klik (BR 27.4).
 *
 * ⚠ NİYƏ VAR (2026-10-02 auditi): admin zənciri «axtarış → kart klik → oynatma →
 *   tamamlama» göstərir, amma `/api/events/search` və `/api/events/ui` uclarını heç bir
 *   client çağırmırdı — ilk iki pillə həmişə 0 idi. Sayt, iOS və Android eyni ucları çağırır.
 * ⚠ YALNIZ GİRİŞLİ İSTİFADƏÇİ (uclar avtorizasiya tələb edir); istifadəçi və vaxtı server
 *   özü yazır (BR 27.3). Kart slug ilə gedir — id-ni server tapır.
 * ⚠ HEÇ VAXT XƏTA ATMIR, HEÇ NƏYİ GÖZLƏTMİR — analitika istifadəçi axınını dayandırmamalıdır.
 * ⚠ ES2015 həddi (PERFORMANCE.md): `Set` yox, sadə obyekt; async/await yox.
 */
import { authStatus, readSession } from '@/lib/session'

/** `UiEventType.CardClick` (backend enum dəyəri 3). */
const CARD_CLICK = 3
/** Yazmaq dayanandan sonra gözləmə — «g», «gu», «gun» üç ayrı axtarış sayılmasın. */
const SEARCH_SETTLE_MS = 1500

const sentQueries: { [query: string]: true } = {}
let searchTimer: ReturnType<typeof setTimeout> | null = null

function post(path: string, body: unknown): void {
  if (!readSession()) return
  authStatus(path, { method: 'POST', body: JSON.stringify(body) }).then(
    () => undefined,
    () => undefined,
  )
}

/** Axtarış nəticəsi gəldi — hadisə yalnız ifadə 1,5 saniyə dəyişməyəndə göndərilir. */
export function scheduleSearchEvent(query: string, resultCount: number): void {
  if (searchTimer !== null) clearTimeout(searchTimer)
  const text = query.trim().toLowerCase()
  if (text.length < 2) return
  searchTimer = setTimeout(() => {
    searchTimer = null
    if (sentQueries[text]) return
    sentQueries[text] = true
    post('/api/events/search', { queryText: text.slice(0, 200), resultCount: resultCount })
  }, SEARCH_SETTLE_MS)
}

/** Kontent kartının açılışı — `page` səthi bildirir («webtv» · «tv»). */
export function trackCardClick(slug: string, page: string): void {
  post('/api/events/ui', { eventType: CARD_CLICK, page: page, contentSlug: slug })
}
